import {LEARN_CHARACTER_TYPE, MaxiDingConfig} from "../configuration/configurations";

export const getLearnedChars = (charType = LEARN_CHARACTER_TYPE.CHINESE) => {
    const endpointUrl = MaxiDingConfig.learnCharacter + '/' + charType;
    return fetch(endpointUrl, {
        method: 'GET',
    });
}

export const addNewChar = (charType = LEARN_CHARACTER_TYPE.CHINESE, charWord = '', token) => {
    const requestBody = JSON.stringify({
        charWord,
        charType,
    });
    return fetch(MaxiDingConfig.learnCharacter, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token},
        body: requestBody,
    });
}

export const updateRememberedChars = (charType = LEARN_CHARACTER_TYPE.CHINESE, ids = [], token) => {
    const requestBody = JSON.stringify({
        charType,
        ids,
    });
    return fetch(MaxiDingConfig.learnCharacter, {
        method: 'PUT',
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token},
        body: requestBody,
    });
}